
import {Component} from 'vue-property-decorator'
import Vue from 'vue'
import UiIcon from '@/components/common/UiIcon.vue'
import {validationMixin} from 'vuelidate'
import {namespace} from 'vuex-class'

const uiModule = namespace('ui')
const authModule = namespace('auth')

@Component({
  components: {UiIcon},
  mixins: [validationMixin]
})
export default class App extends Vue {
  @authModule.Getter('meGetter') me: any
  @uiModule.Getter('isLoadingGetter') isLoading: any

  sections = [
    {path: '/config/sujet', label: 'Sujets', description: 'Objets de vos emails', icon: 'mail'},
    {path: '/config/bloctext', label: 'Blocs de texte', description: 'Contenus de vos emails', icon: 'text'},
    {path: '/config/blocsms', label: 'Blocs de SMS', description: 'Messages réutilisables', icon: 'message'},
    {
      path: '/config/documentGenerique',
      label: 'Documents génériques',
      description: 'Pièces jointes partagées',
      icon: 'file'
    },
    {path: '/config/option', label: 'Options', description: 'Options des propositions', icon: 'settings'}
  ]

  mounted() {
    if (this.me && this.me.CODE_ROLE_CONSEILLER !== 'A') {
      this.$router.replace({name: 'Dashboard'})
    }
  }
}
